/*
 * Purpose : Service Class to handle declare tools create/delete/edit, emails etc services
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import uniqid from 'uniqid';
import axios from 'axios';
import { readAndCompressImage } from 'browser-image-resizer';
import convert from 'heic-convert';
import moment from 'moment';

import { harwareFabMappings } from './../config/constants';
import {
    createExcesstransactions,
    createExcessgeneral,
    createExcesshardwarefabconfig,
    createExcesshardwaresubfabconfig,
    createExcessmissingfaultyparts,
    createExcessfaultyparts,
    createExcesstoolpictures,
    deleteExcesstransactions,
    deleteExcessgeneral,
    deleteExcesshardwarefabconfig,
    deleteExcesshardwaresubfabconfig,
    deleteExcessmissingfaultyparts,
    deleteExcessfaultyparts,
    deleteExcesstoolpictures,
    updateExcesstransactions,
    updateExcessgeneral,
    updateExcesshardwarefabconfig,
    updateExcesshardwaresubfabconfig,
    updateExcessmissingfaultyparts,
    updateExcessfaultyparts,
    updateExcesstoolpictures
} from './../graphql/mutations';
import {
    listExcesstransactionss,
    listExcessgenerals,
    listExcesshardwarefabconfigs,
    listExcesshardwaresubfabconfigs,
    listExcessmissingfaultypartss,
    listExcessfaultypartss,
    listExcesstoolpicturess
} from './../graphql/queries';
import { API, graphqlOperation, Storage } from 'aws-amplify';

export class PostFormService {
    async postForm(user, formdata) {
        try {
            //console.log("user=>", user)
            //console.log("formdata=>", formdata)
            this.toolid = formdata.values.transaction.toolid
            //console.log("toolid 2=> ", this.toolid)
            const oldTransId = formdata.values.transaction.transactionid
            try {
                await this.dataLoader(formdata.values, formdata.draft, user)
            } catch (error) {
                console.log("error=>", error)
                const reqBody = {
                    level: "error",
                    message: "Error while posting transaction data. error: " + error
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                await this.removeTransaction(this.transactionid)
                throw new Error("Error inserting excess form data. Please check logs for more details")
            }
            // if (oldTransId) {
            //     this.removeTransaction(oldTransId)
            // }
            return this.transactionid + "~" + this.toolid + "~" + oldTransId + "~" + this.initiator

        } catch (error) {

        }
    }

    async postFileData(transactionid, toolId, formData, draft, requester) {
        try {
            //console.log("formData==>", formData)
            await this.fileDataLoader(transactionid, formData);
            if (!draft || draft === "false") {
                await this.sendEmail(transactionid, toolId, '', '', "submit", requester)
            }
            return transactionid;
        } catch (error) {
            const reqBody = {
                level: "error",
                message: "Error while posting transaction files data. error: " + error
            }
            axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            await this.removeTransaction(transactionid)
            throw new Error("Error inserting excess file data. Please check logs for more details")
        }
    }

    async fileDataLoader(transactionid, formData) {
        try {
            let descriptions = {};
            let filesUploaded = {};
            for (var [key, value] of formData.entries()) {
                //console.log("key : ", key, "\n value : ", value);
                if (key.indexOf("description") !== -1) {
                    descriptions[key] = value
                }
                else {
                    filesUploaded[key] = value
                }
            }
            // duplicate file removal
            //console.log("filesUploaded==>",_.defaultsDeep(filesUploaded) )
            let fv = [];
            const filteredObj = {}
            for (const i of Object.keys(filesUploaded)) {
                //console.log("fv array ==>",fv)
                if (fv.length !== 0 && fv.indexOf(filesUploaded[i]["name"]) !== -1) {
                    console.log("objects are same")
                }
                else {
                    filteredObj[i] = filesUploaded[i]
                    fv.push(filteredObj[i]["name"])
                }
            }
            //console.log("filteredObj =>",filteredObj)
            filesUploaded = filteredObj

            for (let key of Object.keys(descriptions)) {
                const keys = key.split("-")
                const fileKey = key.replace("description", "files")
                if (keys.length !== 4) {
                    throw new Error("File key incorrectly framed.")
                }
                const record = {}
                record.transactionid = transactionid
                record.systemtype = keys[1]
                record.description = descriptions[key]
                const fileBody = filesUploaded;
                let file = null;
                if (fileBody && fileBody[fileKey]) {
                    let fileNameDet = fileBody[fileKey].name.split(".");
                    var n = fileNameDet[0].indexOf('-$');
                    fileNameDet[0] = fileNameDet[0].substring(0, n !== -1 ? n : fileNameDet[0].length);
                    let extension = fileNameDet[1];
                    //console.log("extension==>", extension)
                    if (extension.toLowerCase() === "heic" || extension.toLowerCase() === "heif") {
                        extension = "jpg"
                    }
                    extension = extension.toLowerCase();
                    let mimeType = fileBody[fileKey].type;
                    //console.log("mimeType=>", mimeType)
                    if (mimeType === "" || mimeType === "image/heic" || mimeType === "image/heif") {
                        mimeType = "image/jpeg"
                    }
                    // let fileName = fileNameDet[0].replace("%", " percent") + "-$" + transactionid + "." + extension
                    let fileName = fileNameDet[0].replace(/%/g, "").replace(/ /g, "").replace(/@/g, "").replace(/#/g, "").replace('$', "").replace(/&/g, "").replace('*', "").replace('(', "").replace(')', "") + "-$" + transactionid + "." + extension
                    console.log("fileName=>", fileName)
                    //console.log("fileBody=>", fileBody)
                    //console.log("fileBody Mime =>", fileBody[fileKey].type)
                    //console.log("fileKey=>", fileKey)
                    //console.log("file=>", fileBody[fileKey])

                    record.toolfilename = fileName
                    record.md5 = "NA"
                    record.mimetype = mimeType

                    file = fileBody[fileKey];

                    let outputBuffer = null;
                    if (record.systemtype !== "configfiles") {
                        if (file.name.indexOf("heic") !== -1 || file.name.indexOf("heif") !== -1) {
                            var buffer = await file.arrayBuffer();
                            try {
                                outputBuffer = await convert({
                                    buffer: Buffer.from(buffer), // the HEIC file buffer
                                    format: 'JPEG',      // output format
                                    quality: 0           // the jpeg compression quality, between 0 and 1
                                });
                                file = new Blob([new Uint8Array(outputBuffer)])//Buffer.from(outputBuffer);
                            } catch (error) {
                                const reqBody = {
                                    level: "error",
                                    message: "Error while converting heic to jpg. transactionid : " + transactionid + " , error : " + JSON.stringify(error)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                            }
                        }
                        const config = {
                            quality: 0.8,
                            maxWidth: 700,
                            maxHeight: 700,
                            mimeType: 'image/jpeg'
                        };
                        file = await readAndCompressImage(file, config);
                    }
                    await Storage.put(record.toolfilename, file, {
                        progressCallback(progress) {
                            console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
                        },

                        contentType: record.mimetype,
                        level: 'public'
                    })
                        .then(async res => {
                            console.log("res from storage =>", res)
                            try {
                                record.id = Math.random().toString(36).slice(2)
                                record.toolpicture = res.key
                                await API.graphql(graphqlOperation(createExcesstoolpictures, { input: record }))
                                    .then(result => {
                                        console.log(`inserted createExcesstoolpictures`)
                                    }
                                    )
                                    .catch(error => {
                                        console.log("error==>", error)
                                        throw Error(`Error while inserting createExcesstoolpictures`)
                                    });

                            } catch (error) {
                                throw new Error("Error inserting file data..")
                            }
                        }).catch(async (err) => {
                            await Storage.put(record.toolfilename, file, {
                                progressCallback(progress) {
                                    console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
                                },

                                contentType: record.mimetype,
                                level: 'public'
                            })
                                .then(async res => {
                                    console.log("res from storage =>", res)
                                    try {
                                        record.id = Math.random().toString(36).slice(2)
                                        record.toolpicture = res.key
                                        await API.graphql(graphqlOperation(createExcesstoolpictures, { input: record }))
                                            .then(result => {
                                                console.log(`inserted createExcesstoolpictures`)
                                            }
                                            )
                                            .catch(error => {
                                                console.log("error==>", error)
                                                throw Error(`Error while inserting createExcesstoolpictures`)
                                            });

                                    } catch (error) {
                                        throw new Error("Error inserting file data..")
                                    }
                                }).catch((err) => {
                                    console.log("err from storage=>", err)
                                    const reqBody = {
                                        level: "error",
                                        message: "Error while inserting data to S3. toolfilename : " + record.toolfilename + " , error : " + JSON.stringify(err)
                                    }
                                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                        reqBody,
                                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                    );

                                });

                        })

                }

            }
        } catch (error) {
        }
    }

    async sendEmail(transactionid, toolId, reviewer, reason, action, requester) {
        // email sending to submit to list
        const emailList = []
        const reqBody = {
            "toList": [],
            "ccList": [],
            "toolId": toolId,
            "transactionId": transactionid,
            "reviewer": reviewer,
            "action": action,
            "reason": reason
        }
        let query = "";
        if (action === "submit") {
            query = `query 
            {
                listExcessuserroless(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}, filter: {submitlist: {eq: "Yes"}}) {
                    items {
                        email
                    }
                }
            }`;
        }
        else if (action === "approval") {
            query = `query 
            {
                listExcessuserroless(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}, filter: {approvelist: {eq: "Yes"}}) {
                    items {
                        email
                    }
                }
            }`;
            reqBody.ccList = [reviewer]
        }
        else if (action === "reject") {
            reqBody.toList = [reviewer]
        }
        if (action === "submit" || action === "approval") {
            await API.graphql(graphqlOperation(query))
                .then(
                    PromiseValue => {
                        //console.log("PromiseValue1", PromiseValue.data.listExcessuserroless.items);
                        let rec = null;
                        for (let [index, pic] of PromiseValue.data.listExcessuserroless.items.entries()) {
                            rec = { ...pic }
                            //console.log("rec=>", rec)
                            for (const key of Object.keys(rec)) {
                                emailList.push(rec[key])
                            }
                        }
                        //console.log("emailList=>", emailList)
                        reqBody.toList = emailList
                    }
                ).catch(err => {
                    console.log("err=>", err)
                    const reqBody = {
                        level: "error",
                        message: "Error while getting email list. error : " + JSON.stringify(err)
                    }
                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                        reqBody,
                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                    );
                });
        }
        reqBody.ccList.push(requester)
        console.log("reqBody=>", reqBody)
        //console.log("REACT_APP_REST_API_END_POINT =>", `${process.env.REACT_APP_REST_API_END_POINT}sendEmail`)
        await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}sendEmail`, reqBody, { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } })
            .then(res => {
                console.log("res from email sending=>", res)
            })
            .catch(err => {
                console.log("error in sending mail =>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while sending email. error : " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            })
    }
    async dataLoader(formData, draft, user) {
        if (formData && Object.keys(formData).length > 0) {
            if (!formData.transaction) {
                throw Error("Transaction object not defined")
            }
            // Deal with transaction object first. It is parent of all
            const transaction = formData.transaction
            this.transactionid = uniqid.time()
            //console.log("formData.transaction.initiator==>", formData.transaction.initiator)
            transaction.initiator = (formData.transaction.initiator !== null && formData.transaction.initiator !== "") ? formData.transaction.initiator : user//"testuser@globalfoundries.com";
            // for mail use
            this.initiator = (formData.transaction.initiator !== null && formData.transaction.initiator !== "") ? formData.transaction.initiator : user//"testuser@globalfoundries.com";
            if (draft) {
                transaction.approved = "DRAFT"
            }
            else {
                transaction.approved = "NO"
            }
            transaction.id = this.transactionid
            transaction.transactionid = this.transactionid
            transaction.lastUpdatedBy = user
            transaction.date = moment().format("YYYY-MM-DD")
            if (!transaction.date || transaction.date === "") {
                delete transaction.date
            }
            if (!transaction.toolavailabledate || transaction.toolavailabledate === "") {
                delete transaction.toolavailabledate
            }
            //console.log("transaction details =>", transaction)
            let postTransaction = false;

            await API.graphql(graphqlOperation(createExcesstransactions, { input: transaction }))
                .then(result => {
                    //console.log("result==>", result)
                    postTransaction = true;
                }
                ).catch(error => {
                    console.log("Error while inserting transaction details ==>", error)
                    const reqBody = {
                        level: "error",
                        message: "Error while inserting transaction details. toolid : " + transaction.toolid + " , error : " + JSON.stringify(error)
                    }
                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                        reqBody,
                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                    );
                    throw Error("Error while inserting transaction details")
                });


            if (postTransaction) {
                console.log("transaction inserted successfully!")
                delete formData.transaction
                for (let section of Object.keys(formData)) {
                    if (!section || Object.keys(section).length <= 0) {
                        throw Error("Harware fab values not defined")
                    }
                    if (section === "hardwarefab") {
                        const recordset = formData[section]
                        //console.log("recordset==>", recordset)
                        for (let system of Object.keys(recordset)) {
                            for (let row of recordset[system]) {
                                const record = {}
                                //console.log("row==>",row)
                                record.id = Math.random().toString(36).slice(2)
                                record.transactionid = this.transactionid
                                record.systemtype = harwareFabMappings[system]
                                record.description = row.description ? row.description : ""
                                record.quantity = row.quantity ? row.quantity : ""
                                record.status = row.status ? row.status : ""

                                await API.graphql(graphqlOperation(createExcesshardwarefabconfig, { input: record }))
                                    .then(result => {
                                        //console.log(`inserted into ${section} for ${this.transactionid}`)
                                    }
                                    )
                                    .catch(error => {
                                        console.log(`Error while inserting ${section} details=>${error}`)
                                        const reqBody = {
                                            level: "error",
                                            message: `Error while inserting ${section} details. toolid : ${transaction.toolid} , error : ${JSON.stringify(error)}`
                                        }
                                        axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                            reqBody,
                                            { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                        );
                                        throw Error(`Error while inserting ${section} details`)
                                    });
                            }
                        }
                        console.log("transaction Hardware Fab data inserted successfully!")
                    }
                    else if (section === "hardwaresubfab") {
                        for (let row of formData[section]) {
                            row.id = Math.random().toString(36).slice(2)
                            row.transactionid = this.transactionid

                            await API.graphql(graphqlOperation(createExcesshardwaresubfabconfig, { input: row }))
                                .then(result => {
                                    //console.log(`inserted into ${section} for ${this.transactionid}`)
                                }
                                )
                                .catch(error => {
                                    console.log(`Error while inserting ${section} details=>${error}`)
                                    const reqBody = {
                                        level: "error",
                                        message: `Error while inserting ${section} details. toolid : ${transaction.toolid} , error : ${JSON.stringify(error)}`
                                    }
                                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                        reqBody,
                                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                    );

                                    throw Error(`Error while inserting ${section} details`)
                                });
                        }
                        console.log("transaction Hardware Sub-Fab data inserted successfully!")
                    }
                    else if (section === "missingparts") {
                        for (let row of formData[section]) {
                            row.id = Math.random().toString(36).slice(2)
                            row.transactionid = this.transactionid

                            await API.graphql(graphqlOperation(createExcessmissingfaultyparts, { input: row }))
                                .then(result => {
                                    //console.log(`inserted into ${section} for ${this.transactionid}`)
                                }
                                )
                                .catch(error => {
                                    console.log(`Error while inserting ${section} details=>${error}`)
                                    const reqBody = {
                                        level: "error",
                                        message: `Error while inserting ${section} details. toolid : ${transaction.toolid} , error : ${JSON.stringify(error)}`
                                    }
                                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                        reqBody,
                                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                    );
                                    throw Error(`Error while inserting ${section} details`)
                                });
                        }
                        console.log("transaction Missing Parts inserted successfully!")
                    } else if (section === "faultyparts") {
                        for (let row of formData[section]) {
                            row.id = Math.random().toString(36).slice(2)
                            row.transactionid = this.transactionid

                            await API.graphql(graphqlOperation(createExcessfaultyparts, { input: row }))
                                .then(result => {
                                    //console.log(`inserted into ${section} for ${this.transactionid}`)
                                }
                                )
                                .catch(error => {
                                    console.log(`Error while inserting ${section} details=>${error}`)
                                    const reqBody = {
                                        level: "error",
                                        message: `Error while inserting ${section} details. toolid : ${transaction.toolid} , error : ${JSON.stringify(error)}`
                                    }
                                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                        reqBody,
                                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                    );
                                    throw Error(`Error while inserting ${section} details`)
                                });
                        }
                        console.log("transaction Faulty Parts inserted successfully!")
                    }
                    else if (section === "general") {
                        const recordset = formData[section]
                        recordset.id = this.transactionid
                        recordset.transactionid = this.transactionid

                        //console.log("general record set =>", recordset);
                        await API.graphql(graphqlOperation(createExcessgeneral, { input: recordset }))
                            .then(result => {
                                //console.log(`inserted into ${section} for ${this.transactionid}`)
                            }
                            )
                            .catch(error => {
                                console.log(`Error while inserting ${section} details=>${error}`)
                                const reqBody = {
                                    level: "error",
                                    message: `Error while inserting ${section} details. toolid : ${transaction.toolid} , error : ${JSON.stringify(error)}`
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );

                                throw Error(`Error while inserting ${section} details`)
                            });
                        console.log("transaction General data inserted successfully!")
                    }
                }
            }
            else {
                throw Error("Error inserting transaction data")
            }
        }
        else {
            throw Error("Form Data not defined")
        }
    }
    /**
* CHG0098917 -  New removeTransaction function creation
* Deletes all records across all Excess Equipment tables
* that belong to a given transactionId.
*
* Handles:
*  - Paginated reads using nextToken
*  - Row-by-row deletes using GraphQL mutations
*  - Conditional S3 file deletion
*  - Error logging to REST endpoint
*  - Every operation is asynchronous
*/

    async removeTransaction(transactionId) {
        console.log(` Deleting all records for ${transactionId}`);

        //  Helper function to log errors
        const logError = async (message, err) => {
            console.log("", message, err?.toString());

            const reqBody = {
                level: "error",
                message: `${message} | transactionId: ${transactionId} | error: ${JSON.stringify(err)}`
            };

            try {
                await axios.post(
                    `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { "x-api-key": process.env.REACT_APP_REST_API_KEY } }
                );
            } catch (logErr) {
                console.error(" Failed to post log:", logErr?.toString());
            }
        };

        /**
  * Tables to clean in sequence.
  * Each entry defines:
  *  - listQuery      → GraphQL list resolver
  *  - deleteMutation → GraphQL delete resolver
  *  - name           → For readable logs
  *  - isS3           → Whether deletion requires S3 cleanup
  */
        const tables = [
            { listQuery: listExcesstransactionss, deleteMutation: deleteExcesstransactions, name: "Transaction" },
            { listQuery: listExcessgenerals, deleteMutation: deleteExcessgeneral, name: "General" },
            { listQuery: listExcesshardwarefabconfigs, deleteMutation: deleteExcesshardwarefabconfig, name: "Hardware Fab" },
            { listQuery: listExcesshardwaresubfabconfigs, deleteMutation: deleteExcesshardwaresubfabconfig, name: "Hardware Sub-Fab" },
            { listQuery: listExcessmissingfaultypartss, deleteMutation: deleteExcessmissingfaultyparts, name: "Missing Parts" },
            { listQuery: listExcessfaultypartss, deleteMutation: deleteExcessfaultyparts, name: "Faulty Parts" },
            { listQuery: listExcesstoolpicturess, deleteMutation: deleteExcesstoolpictures, name: "Tool Pictures", isS3: true }
        ];

        //  Process each table one by one
        for (const table of tables) {
            console.log(` Cleaning table: ${table.name}`);

            let nextToken = null;
            let page = 1;

            do {
                try {
                    console.log(` Fetching page ${page} of ${table.name}`);
                    //  PAGINATED QUERY using nextToken
                    const resp = await API.graphql(
                        graphqlOperation(table.listQuery, {
                            limit: parseInt(process.env.REACT_APP_TRANSACTION_TABLE_LIMIT),     // IMPORTANT: evn variable limit used 
                            nextToken,       // next page
                            filter: { transactionid: { eq: transactionId } }
                        })
                    );
                    const tableKey = Object.keys(resp.data)[0];
                    const items = resp?.data?.[tableKey]?.items || [];
                    nextToken = resp?.data?.[tableKey]?.nextToken || null;

                    console.log(` ${table.name} page ${page} rows: ${items.length}`);
                    page++;

                    // Delete each row in the page
                    for (const item of items) {
                        try {
                            const deleteResp = await API.graphql(
                                graphqlOperation(table.deleteMutation, { input: { id: item.id } })
                            );

                            console.log(` Deleted ${table.name} row: ${item.id}`);

                            //  Delete S3 file if required
                            if (table.isS3 && deleteResp?.data?.deleteExcesstoolpictures?.toolpicture) {
                                try {
                                    const fileKey = deleteResp.data.deleteExcesstoolpictures.toolpicture;
                                    await Storage.remove(fileKey);
                                    console.log(` Deleted S3 file: ${fileKey}`);
                                } catch (s3Err) {
                                    await logError(`Error deleting S3 file from ${table.name}`, s3Err);
                                }
                            }

                        } catch (delErr) {
                            await logError(`Error deleting ${table.name} row`, delErr);
                        }
                    }

                } catch (err) {
                    await logError(`Error querying ${table.name} table`, err);
                }
                // Continue while nextToken exists
            } while (nextToken);
            console.log(`${table.name} table cleanup complete`);
        }
        console.log(` All records deleted for transactionId: ${transactionId}`);
        return transactionId;
    }



    async removeTransactionDetails(transactionId) {
        console.log(`deleting all records for ${transactionId}`)
        // deleting transaction data
        await API.graphql(graphqlOperation(listExcesstransactionss, { limit: process.env.REACT_APP_TRANSACTION_TABLE_LIMIT, filter: { transactionid: { eq: transactionId } } }))
            .then(
                response => {
                    //console.log("deleting transaction data")
                    const a = response.data.listExcesstransactionss.items;
                    a.forEach(element => {
                        API.graphql(graphqlOperation(deleteExcesstransactions, { input: { id: element.id } }))
                            // .then(result => 
                            //     //console.log("deleteExcesstransactions result=>", result)
                            // )
                            .catch(err => {
                                console.log("err deleting transaction data delete=>", err.toString())
                                const reqBody = {
                                    level: "error",
                                    message: "Error while deleting transaction data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                                throw err;
                            })
                    });
                }
            )
            .catch(err => {
                console.log("err getting id for transaction data delete=>", err.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while getting id for transaction data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                throw err;
            })
        console.log("Transaction data deleted")
        //deleting general data
        await API.graphql(graphqlOperation(listExcessgenerals, { limit: process.env.REACT_APP_GENERAL_TABLE_LIMIT, filter: { transactionid: { eq: transactionId } } }))
            .then(
                response => {
                    //console.log("deleting general data")
                    const a = response.data.listExcessgenerals.items;
                    a.forEach(element => {
                        API.graphql(graphqlOperation(deleteExcessgeneral, { input: { id: element.id, transactionid: element.transactionid } }))
                            // .then(result => 
                            //     //console.log("deleteExcessgeneral result =>", result)
                            // )
                            .catch(err => {
                                console.log("err general data delete=>", err.toString())
                                const reqBody = {
                                    level: "error",
                                    message: "Error while general data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                                throw err;
                            })
                    });
                }
            )
            .catch(err => {
                console.log("err getting id for general data delete=>", err.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while getting id for general data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                throw err;
            })
        console.log("General data deleted")
        // deleteing hardware fab config data
        await API.graphql(graphqlOperation(listExcesshardwarefabconfigs, { limit: process.env.REACT_APP_HARDWAREFAB_TABLE_LIMIT, filter: { transactionid: { eq: transactionId } } }))
            .then(
                response => {
                    //console.log("deleting hardware fab config data")
                    const a = response.data.listExcesshardwarefabconfigs.items;
                    a.forEach(element => {
                        API.graphql(graphqlOperation(deleteExcesshardwarefabconfig, { input: { id: element.id, transactionid: element.transactionid } }))
                            // .then(result => 
                            //     //console.log("deleteExcesshardwarefabconfig result=>", result)
                            // )
                            .catch(err => {
                                console.log("err hardwarefab data delete=>", err.toString())
                                const reqBody = {
                                    level: "error",
                                    message: "Error while hardwarefab data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                                throw err;
                            })
                    });
                }
            )
            .catch(err => {
                console.log("err getting id for hardwarefab data delete=>", err.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while getting id for hardwarefab data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            })
        console.log("Hardware Fab data deleted")
        // deleting hardware fab sub config data
        await API.graphql(graphqlOperation(listExcesshardwaresubfabconfigs, { limit: process.env.REACT_APP_HARDWARESUBFAB_TABLE_LIMIT, filter: { transactionid: { eq: transactionId } } }))
            .then(
                response => {
                    //console.log("deleting hardware sub fab config data")
                    const a = response.data.listExcesshardwaresubfabconfigs.items;
                    a.forEach(element => {
                        API.graphql(graphqlOperation(deleteExcesshardwaresubfabconfig, { input: { id: element.id, transactionid: element.transactionid } }))
                            // .then(result => 
                            //     //console.log("deleteExcesshardwaresubfabconfig result=>", result)
                            // )
                            .catch(err => {
                                console.log("ere hardware subfab data delete=>", err.toString())
                                const reqBody = {
                                    level: "error",
                                    message: "Error while hardware subfab data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                                throw err;
                            })
                    });
                }
            )
            .catch(err => {
                console.log("err getting id for hardware subfab data delete=>", err.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while getting id for hardware subfab data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                throw err;
            })
        console.log("Hardware Sub-Fab data deleted")
        // deleting missing parts data
        await API.graphql(graphqlOperation(listExcessmissingfaultypartss, { limit: process.env.REACT_APP_MISSINGPARTS_TABLE_LIMIT, filter: { transactionid: { eq: transactionId } } }))
            .then(
                response => {
                    //console.log("deleting missing or fault parts data")
                    const a = response.data.listExcessmissingfaultypartss.items;
                    a.forEach(element => {
                        API.graphql(graphqlOperation(deleteExcessmissingfaultyparts, { input: { id: element.id, transactionid: element.transactionid } }))
                            // .then(result => 
                            //     //console.log("deleteExcessmissingfaultyparts result=>", result)
                            // )
                            .catch(err => {
                                console.log("ere missing parts data delete=>", err.toString())
                                const reqBody = {
                                    level: "error",
                                    message: "Error while missing parts data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                                throw err;
                            })
                    });
                }
            )
            .catch(err => {
                console.log("err getting id for missing parts data delete=>", err.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while getting id for missing parts data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                throw err;
            })
        console.log("Missing Faulty Parts data deleted")
        // deleting file data
        await API.graphql(graphqlOperation(listExcesstoolpicturess, { limit: process.env.REACT_APP_TOOLPICTURES_TABLE_LIMIT, filter: { transactionid: { eq: transactionId } } }))
            .then(
                response => {
                    //console.log("deleting missing or fault parts data")
                    const a = response.data.listExcesstoolpicturess.items;
                    a.forEach(element => {
                        API.graphql(graphqlOperation(deleteExcesstoolpictures, { input: { id: element.id, transactionid: element.transactionid } }))
                            .then(result => {
                                //console.log("deleteExcesstoolpictures result=>", result)
                                //console.log("deleteExcesstoolpictures result=>", result.data.deleteExcesstoolpictures.toolpicture)
                                Storage.remove(result.data.deleteExcesstoolpictures.toolpicture)
                                    // .then(result => 
                                    //     //console.log("result delete storage==>", result)
                                    // )
                                    .catch(err => {
                                        console.log("err deleting S3 object=>", err.toString())
                                        const reqBody = {
                                            level: "error",
                                            message: "Error while deleting S3 object. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                        }
                                        axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                            reqBody,
                                            { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                        );
                                    });
                            })
                            .catch(err => {
                                console.log("err toolpictures data delete=>", err.toString())
                                const reqBody = {
                                    level: "error",
                                    message: "Error while toolpictures data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                                }
                                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                                );
                                throw err;
                            })
                    });
                }
            )
            .catch(err => {
                console.log("err getting id for toolpictures data delete=>", err.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while getting id for toolpictures data delete. transactionId : " + transactionId + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                throw err;
            })
        console.log("Tool Pictures/files data deleted")
        return transactionId;
    }

    async updateTransaction(transactionid, toolId, approved, reviewer, reviewerremarks, requester) {
        // console.log("transactionid=>", transactionid)
        // console.log("toolId=>", toolId)
        // console.log("approved=>", approved)
        // console.log("reviewer=>", reviewer)
        // console.log("reviewerremarks=>", reviewerremarks)
        let resultCode = null;
        await API.graphql(graphqlOperation(updateExcesstransactions,
            {
                input: {
                    id: transactionid,
                    transactionid: transactionid,
                    approved: approved,
                    reviewer: reviewer,
                    reviewerremarks: reviewerremarks,
                    processed: "N"
                }
            }))
            .then(async result => {
                if (approved === "APPROVED") {
                    //update general table
                    await API.graphql(graphqlOperation(updateExcessgeneral,
                        {
                            input: {
                                id: transactionid,
                                transactionid: transactionid,
                                processed: "N"
                            }
                        }))
                        .then(res => console.log("General table updated"))
                        .catch(e => {
                            console.log("error in general table update")
                            throw e;
                        });
                    // update hardwarefab table
                    await API.graphql(graphqlOperation(listExcesshardwarefabconfigs, { limit: process.env.REACT_APP_HARDWAREFAB_TABLE_LIMIT, filter: { transactionid: { eq: transactionid } } }))
                        .then(
                            response => {
                                const a = response.data.listExcesshardwarefabconfigs.items;
                                a.forEach(element => {
                                    API.graphql(graphqlOperation(updateExcesshardwarefabconfig, { input: { id: element.id, transactionid: element.transactionid, processed: "N" } }))
                                        .then(res => console.log("Hardwarefab table updated"))
                                        .catch(err => {
                                            console.log("err hardwarefab table update=>", err)
                                            throw err;
                                        })
                                });
                            }
                        )
                        .catch(err => {
                            console.log("err getting id for hardwarefab table update =>", err)
                        });
                    // update hardware subfab table
                    await API.graphql(graphqlOperation(listExcesshardwaresubfabconfigs, { limit: process.env.REACT_APP_HARDWAREFAB_TABLE_LIMIT, filter: { transactionid: { eq: transactionid } } }))
                        .then(
                            response => {
                                const a = response.data.listExcesshardwaresubfabconfigs.items;
                                a.forEach(element => {
                                    API.graphql(graphqlOperation(updateExcesshardwaresubfabconfig, { input: { id: element.id, transactionid: element.transactionid, processed: "N" } }))
                                        .then(res => console.log("Hardware subfab table updated"))
                                        .catch(err => {
                                            console.log("err hardware subfab table update=>", err)
                                            throw err;
                                        })
                                });
                            }
                        )
                        .catch(err => {
                            console.log("err getting id for hardware subfab table update =>", err)
                        });
                    // update missing table
                    await API.graphql(graphqlOperation(listExcessmissingfaultypartss, { limit: process.env.REACT_APP_HARDWAREFAB_TABLE_LIMIT, filter: { transactionid: { eq: transactionid } } }))
                        .then(
                            response => {
                                const a = response.data.listExcessmissingfaultypartss.items;
                                a.forEach(element => {
                                    API.graphql(graphqlOperation(updateExcessmissingfaultyparts, { input: { id: element.id, transactionid: element.transactionid, processed: "N" } }))
                                        .then(res => console.log("missing table updated"))
                                        .catch(err => {
                                            console.log("err missing table update=>", err)
                                            throw err;
                                        })
                                });
                            }
                        )
                        .catch(err => {
                            console.log("err getting id for missing table update =>", err)
                        });
                    // update tool picture table
                    await API.graphql(graphqlOperation(listExcesstoolpicturess, { limit: process.env.REACT_APP_HARDWAREFAB_TABLE_LIMIT, filter: { transactionid: { eq: transactionid } } }))
                        .then(
                            response => {
                                const a = response.data.listExcesstoolpicturess.items;
                                a.forEach(element => {
                                    API.graphql(graphqlOperation(updateExcesstoolpictures, { input: { id: element.id, transactionid: element.transactionid, processed: "N" } }))
                                        .then(res => console.log("tool picture table updated"))
                                        .catch(err => {
                                            console.log("err tool picture table update=>", err)
                                            throw err;
                                        })
                                });
                            }
                        )
                        .catch(err => {
                            console.log("err getting id for tool picture table update =>", err)
                        });
                }


                //console.log("result==>", result)
                if (approved === "APPROVED") {
                    await this.sendEmail(transactionid, toolId, reviewer, reviewerremarks, "approval", requester)
                }
                else {
                    await this.sendEmail(transactionid, toolId, reviewer, reviewerremarks.substring(3), "reject", requester)
                }
                resultCode = 200
            }
            )
            .catch(error => {
                console.log("err updating transaction data=>", error.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while updating transaction data. transactionId : " + transactionid + " , toolid : " + toolId + "  , error: " + JSON.stringify(error)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                resultCode = 400
            });

        return resultCode;
    }
    async updateInitiator(transactionid, toolId, email, reviewer) {
        console.log("transactionid=>", transactionid)
        console.log("toolId=>", toolId)
        console.log("email=>", email)
        console.log("reviewer=>", reviewer)

        let resultCode = null;
        await API.graphql(graphqlOperation(updateExcesstransactions,
            {
                input: {
                    id: transactionid,
                    transactionid: transactionid,
                    initiator: email.toLowerCase(),
                    lastUpdatedBy: reviewer.toLowerCase()
                }
            }))
            .then(async result => {
                //console.log("result==>", result)
                // if (approved === "APPROVED") {
                //     await this.sendEmail(transactionid, toolId, reviewer, reviewerremarks, "approval")
                // }
                // else {
                //     await this.sendEmail(transactionid, toolId, reviewer, reviewerremarks.substring(3), "reject")
                // }
                resultCode = 200
            }
            )
            .catch(error => {
                console.log("err reassigning transaction data=>", error.toString())
                const reqBody = {
                    level: "error",
                    message: "Error while reassigning transaction data. transactionId : " + transactionid + " , toolid : " + toolId + "  , error: " + JSON.stringify(error)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                resultCode = 400
            });
        return resultCode;
    }
}
//module.exports = PostFormService